module.exports = __webpack_public_path__ + "static/media/SuperShuttle_android_1.ababb5be.jpg";